import { CloseIcon } from '@/components/UI/svg/Ecocredits';
import { Modal } from 'antd';
import React, { useEffect } from 'react';
import css from './index.module.scss';
import './index.scss';
interface props {
    children: React.ReactElement;
    closeModal: () => void;
    style?: React.CSSProperties;
    visible: boolean;
    className?: string;
    zIndex?: number;
    afterOpen?: () => void;
}

const EcoModal: React.FC<props> = ({ children, closeModal, style, visible, className = '', zIndex = 1200, afterOpen }) => {
    const resetBodyStyle = () => {
        const modalEle: HTMLElement | null = document.body?.querySelector('.full-modal-ecocredits');
        if (modalEle) {
            // 有可能弹窗稍微小一点
            if (modalEle.offsetHeight >= window.innerHeight - 100) {
                //document.body.style.setProperty('overflow', 'hidden', 'important');
            }
        }
    };

    useEffect(() => {
        if (visible) {
            afterOpen?.();
            setTimeout(() => {
                resetBodyStyle();
            }, 50);
        } else {
            //document.body.style.setProperty('overflow', 'hidden');
        }
    }, [visible]);

    return (
        <Modal
            width={980}
            bodyStyle={style}
            className={`${css.modal} ${className} full-modal-ecocredits`}
            open={visible}
            visible={visible}
            closable={false}
            footer={null}
            zIndex={zIndex}
            getContainer={false}
        >
            <div className="modal-header">
                <span onClick={closeModal} className="icon">
                    <CloseIcon />
                </span>
            </div>
            <div className="modal-content modal-FullScreenModal">{children}</div>
        </Modal>
    );
};

export default EcoModal;
